import { render, staticRenderFns } from "./IVR.vue?vue&type=template&id=02ba0822&"
import script from "./IVR.vue?vue&type=script&lang=js&"
export * from "./IVR.vue?vue&type=script&lang=js&"
import style0 from "./IVR.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports